<template>
  <div>
    <Menu activeName="6-1"></Menu>
    <main style="width: 70%;margin: 100px auto 0;">
      <span style="font-size: 26px;font-weight: bold;display: flex;align-items: self-start;">更新日志</span>
      <el-divider></el-divider>
      <div>
        <el-timeline :reverse="false" style="display: flex;flex-direction:column;align-items: flex-start;">
          <el-timeline-item
            v-for="(item, index) in versionList"
            :key="index">
            <div style="display: flex;flex-direction: column;align-items: flex-start;">
              <span style="font-size: 18px;">{{ item.version }}</span>
              <el-tag type="warning" style="padding: 0 4px;line-height: 16px;height: 16px;margin-top: 16px;">
                {{ item.update_time }}
              </el-tag>
              <ul
                style="margin-top: 10px;margin-left: -23px;display: flex;flex-direction: column;align-items: flex-start;">
                <li v-for="(content,contentIndex) in item.content" style="margin-bottom: 10px;" :key="contentIndex">
                  <el-tag size="small" type="success" v-if="content.type===1">新增</el-tag>
                  <el-tag size="small" v-if="content.type===2">优化</el-tag>
                  <el-tag size="small" type="warning" v-if="content.type===3">修复</el-tag>
                  <span style="font-size: 14px;margin-left: 10px;color: #909399;">{{ content.message }}</span>
                </li>
              </ul>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>

    </main>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import {GetVersionLog} from '../api/system.js'

export default {
  name: 'Version',
  components: {Menu},
  data () {
    return {
      reverse: true,
      versionList: []
    }
  },
  mounted () {
    this.getVersionLog()
  },
  methods: {
    getVersionLog () {
      var that = this
      GetVersionLog().then(res => {
        if (res.code === 200) {
          that.versionList = res.data.list
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Version.vue